module.exports = __webpack_public_path__ + "static/media/a60.f41c600c.jpg";